type ApiSlice = { util?: { resetApiState: () => any } };

export const invalidateAllTags =
  (apis: ApiSlice[]) => (store: any) => (next: any) => (action: any) => {
    const isAuthReset =
      action.type === "auth/verifyUser" ||
      action.type === "auth/userLoggedOut" ||
      action.type === "auth/otpVerify";

    if (isAuthReset) {
      apis.forEach((api) => {
        if (api?.util?.resetApiState) {
          store.dispatch(api.util.resetApiState());
        }
      });
    }

    return next(action);
  };
